import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Crown } from "lucide-react";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { transferOwnership } from "../../api/directory";
import { useAuth } from "../../context/AuthContext";
import { isCompanyAdmin } from "../../utils/role";

// نقل ملكية الشركة — يظهر لمدير الشركة فقط عند فتح ملف موظف آخر (غير المالك الحالي).
export const TransferOwnershipButton = ({ targetUser, onDone }) => {
  const { t } = useTranslation();
  const { user, patchUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  if (!isCompanyAdmin(user)) return null;
  if (!targetUser || targetUser.id === user._id) return null;
  if (targetUser.role === "company_admin") return null;

  const doTransfer = async () => {
    setBusy(true);
    try {
      await transferOwnership(targetUser.id);
      toast.success(t("detail.ownership.done"));
      patchUser?.({ role: "system_admin" });
      onDone?.();
    } catch (e) {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="lg:col-span-3 border border-warning/30" data-testid="detail-ownership-zone">
      <p className="label-xs text-warning">{t("detail.ownership.title")}</p>
      <p className="mt-2 text-sm text-muted-foreground">{t("detail.ownership.hint", { name: targetUser.name })}</p>
      {!open ? (
        <NeuButton className="mt-4 flex items-center gap-2 px-4 py-2" data-testid="detail-transfer-open" onClick={() => setOpen(true)}>
          <Crown className="h-4 w-4" /> {t("detail.ownership.button")}
        </NeuButton>
      ) : (
        <div className="mt-4 grid gap-3 sm:max-w-md" data-testid="detail-transfer-confirm">
          <p className="text-xs font-bold">{t("detail.ownership.confirmType", { name: targetUser.name })}</p>
          <NeuInput data-testid="detail-transfer-name" value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={targetUser.name} />
          <div className="flex gap-2">
            <NeuButton variant="primary" className="px-4 py-2" data-testid="detail-transfer-confirm-btn"
                       disabled={busy || typed.trim() !== (targetUser.name || "").trim()} onClick={doTransfer}>
              {busy ? t("app.saving") : t("detail.ownership.confirm")}
            </NeuButton>
            <NeuButton className="px-4 py-2" data-testid="detail-transfer-cancel" onClick={() => setOpen(false)}>
              {t("app.cancel")}
            </NeuButton>
          </div>
        </div>
      )}
    </NeuCard>
  );
};
